import { isCN, psLog } from './utils';
const systemLang = isCN() ? 'zh' : 'en';
export class Translation {
    locales;
    currentLang;
    constructor(options) {
        const { locales, defaultLang = systemLang } = options;
        if (!locales || Object.keys(locales).length === 0) {
            throw new Error('[PageSpy] Locales cannot be empty');
        }
        if (!locales[defaultLang]) {
            throw new Error(`[PageSpy] Language "${defaultLang}" not found`);
        }
        this.locales = locales;
        this.currentLang = defaultLang;
    }
    // key 的类型变为 T，提供具体键名提示
    t(key, lang) {
        const targetLang = lang || this.currentLang;
        const locale = this.locales[targetLang];
        if (!locale) {
            psLog.warn(`Language '${targetLang}' not found, falling back to default`);
            return key;
        }
        return locale[key] || key;
    }
    setLang(lang) {
        if (!this.locales[lang]) {
            psLog.error(`Language '${lang}' is not supported`);
            return;
        }
        this.currentLang = lang;
    }
    getCurrentLang() {
        return this.currentLang;
    }
    getSupportedLangs() {
        return Object.keys(this.locales);
    }
}
